// import{ AddBankForm }from "../WidgetPayment/ AddBankForm"
import { useEffect, useState } from 'react'
import AddBankForm from '../../settings/financial/AddBankForm'
import { useDispatch, useSelector } from 'react-redux';
import { fetchBankAccounts } from 'reducers/auth/auth.actions';
import RegisteredBank from './RegisteredBank';
import Loader from 'components/Loader';
import PostActionItem from 'components/generic-components/post/PostActionItem';
import { CardIcon, FilledCardIcon, MenuBank, PaymentIcon } from 'components/Icons';
import { selectBankAccounts } from 'reducers/auth/auth.selectors';

const AddBank = () => {


const dispatch = useDispatch()
const [bank, setBank] = useState(null)
const [viewBankInfo, setViewBankInfo] = useState(true);
const [viewstatemnetInfo, setViewstatemnetInfo] = useState(false);


    
const bankList = useSelector(selectBankAccounts)


const [isLoading, setIsLoading] = useState()
    useEffect(() => {
        setIsLoading(true)
        dispatch(fetchBankAccounts()).then(
            (resp) => {
            if(resp){
                setBank(resp)
            }
            setIsLoading(false)
        })

 
    }, [setBank,dispatch])

   
const viewBankHandler = () => {
    setViewBankInfo(true)
    setViewstatemnetInfo (false)
  }
  const viewStatementHandler = () => {
    setViewBankInfo(false)
    setViewstatemnetInfo (true)
  }
    

    return (
        <div>
             <Loader isLoadin={isLoading} height={430} size={40}>


<div className='bank-statement-switcher d-flex'>
  <div onClick={viewBankHandler} className={`icon-container ${viewBankInfo && 'activeView'}`}><MenuBank/></div>

<div onClick={viewStatementHandler } className={` icon-container  ${viewstatemnetInfo && 'activeView'}`}>< PaymentIcon/></div>

</div>

    
{

viewBankInfo && 
  (bank?.verification?.payoutStatus ===  "Approved" ? <RegisteredBank bankInfo={bank} /> :   
  <AddBankForm/>
  )
}

{viewstatemnetInfo && <div>bank statement </div>}
   
   

   </Loader>
        </div>
    )
}

export default AddBank
